import { css, useTheme } from "@emotion/react";
import React, { useState } from "react";

import Button from "./Button.jsx";
import generateUniqueId from "./generateUniqueId";
// import ensureArray from "./ensureArray";

// function inArray(array, value, isEmpty = (value) => value === "") {
//   array = ensureArray(array, isEmpty);
//   value = ensureArray(value, isEmpty);
//   if (array.length === 0 || value.length === 0) {
//     return array.length === 0 && value.length === 0;
//   }
//   return value.every((v) => array.includes(v));
// }

export default function ToggleButton({
  // name,
  id,
  type = "checkbox",
  label,
  // value,
  inputProps,
  buttonProps,
  ...restProps
}) {
  const theme = useTheme();
  const [defaultId] = useState(() => `toggle-button-${generateUniqueId()}`);
  id = id ?? defaultId;

  return (
    <>
      <input
        type={type}
        // name={name}
        id={id}
        // value={value}
        css={css`
          ${theme.styleUtils.visuallyHidden}
        `}
        {...inputProps}
        {...restProps}
      />
      <Button htmlFor={id} {...buttonProps}>
        {label}
      </Button>
    </>
  );
}
